"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create_user = void 0;
var api_1 = require("../../../api");
var create_user = function (request) {
    return (0, api_1.apiPost)({
        endpoint: "v3/user/create",
        data: request,
    });
};
exports.create_user = create_user;
